import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createSlots as _createSlots, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = { class: "w-full px-4 text-12px xxl:text-14px overflow-y-auto pb-20" }
const _hoisted_3 = { class: "grid grid-cols-2 mt-4 gap-6" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_5 = { class: "grid grid-cols-2 mt-4 gap-6" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_7 = { class: "space-y-2 pt-2" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "text-12px font-normal text-gray-lp-500 max-w-md" }, " Anda bisa mengaktifkan status Hub kapan saja ", -1)
const _hoisted_9 = { class: "ml-2 rounded-full px-2 py-0 text-14px font-normal text-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Title = _resolveComponent("Title")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      title: _ctx.isEditPage ? 'Ubah Hub' : 'Buat Hub',
      "vertical-separator": _ctx.isEditPage,
      fullpage: !_ctx.isEditPage,
      loading: _ctx.isLoading,
      error: _ctx.isError,
      errorType: _ctx.errCause,
      onTryAgain: {}
    }, _createSlots({
      "top-right": _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_LpButton, {
            "text-color": "white",
            customClass: "w-full p-4",
            title: "Simpan",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isEditPage ? _ctx.showModalConfirmation() : _ctx.onSave())),
            disabled: _ctx.isMandatory || _ctx.errorInput
          }, null, 8, ["disabled"])
        ])
      ]),
      data: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Title, { label: "Detail Hub" }),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_DataWrapper, {
              label: "Nama Hub",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.form.hubName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.hubName = $event)),
                  error: _ctx.error.hubName,
                  isErrorIconInput: false,
                  errorCaption: "Nama Hub telah digunakan. Cek & coba lagi",
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.error.hubName = false)),
                  placeholder: "Masukkan nama Hub"
                }, null, 8, ["modelValue", "error"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: "Kota Hub",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectSearch, {
                  options: _ctx.cityListData,
                  onFilter: _ctx.fetchCityList,
                  keyName: "name",
                  keyValue: "code",
                  placeholder: "Ketik atau pilih kota Hub",
                  modelValue: _ctx.form.originCity,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.originCity = $event)),
                  isLoading: _ctx.isLoadingCity,
                  class: "my-2"
                }, null, 8, ["options", "onFilter", "modelValue", "isLoading"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: "Alamat",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.form.hubAddress,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.hubAddress = $event)),
                  type: "textarea",
                  placeholder: "Masukan alamat Hub"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: "Kecamatan, Kota",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectSearch, {
                  "is-show-error-indicator": false,
                  "error-caption": '',
                  options: _ctx.districts,
                  onFilter: _ctx.fetchDistricts,
                  isLoading: _ctx.isLoadingDistricts,
                  keyName: "name",
                  keyValue: "id",
                  placeholder: "Ketik atau pilih kecamatan, kota",
                  modelValue: _ctx.form.hubDistrict,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.hubDistrict = $event)),
                  class: "my-2"
                }, null, 8, ["options", "onFilter", "isLoading", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('partnerManagement.label.noHandphone'),
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  isErrorIconInput: false,
                  flag: "indonesia",
                  prefix: _ctx.phonePrefix,
                  debounce: 500,
                  format: _ctx.formatNumber,
                  modelValue: _ctx.form.hubPhoneNumber,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.hubPhoneNumber = $event)),
                  error: _ctx.error.phone,
                  onChange: _ctx.validatePhone,
                  errorCaption: 
                _ctx.form.hubPhoneNumber.length > 1
                  ? 'Panjang karakter antara 10-15 angka'
                  : _ctx.$t('partnerManagement.error.phoneHandphoneInvalid')
              ,
                  maxLength: "15",
                  placeholder: "eg. 08123467890"
                }, null, 8, ["prefix", "format", "modelValue", "error", "onChange", "errorCaption"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _hoisted_4,
          _createVNode(_component_Title, { label: "Informasi Kontak" }),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_DataWrapper, {
              label: "Nama",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.form.hubContactPersonName,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.hubContactPersonName = $event)),
                  placeholder: "Masukkan nama kontak"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('partnerManagement.label.noHandphone'),
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  isErrorIconInput: false,
                  flag: "indonesia",
                  prefix: _ctx.phonePrefix,
                  debounce: 500,
                  format: _ctx.formatNumber,
                  modelValue: _ctx.form.hubContactPersonPhoneNumber,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.hubContactPersonPhoneNumber = $event)),
                  error: _ctx.error.contactPhone,
                  onChange: _ctx.validateContactPhone,
                  errorCaption: 
                _ctx.form.hubContactPersonPhoneNumber.length > 1
                  ? 'Panjang karakter antara 10-15 angka'
                  : _ctx.$t('partnerManagement.error.phoneHandphoneInvalid')
              ,
                  maxLength: "15",
                  placeholder: "eg. 08123467890"
                }, null, 8, ["prefix", "format", "modelValue", "error", "onChange", "errorCaption"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: "Email",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.form.hubContactPersonEmail,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.hubContactPersonEmail = $event)),
                  onChange: _ctx.validateEmail,
                  errorCaption: "Format email email salah. Cek & coba lagi",
                  error: _ctx.error.contactEmail,
                  placeholder: "Masukkan email "
                }, null, 8, ["modelValue", "onChange", "error"])
              ]),
              _: 1
            })
          ]),
          _hoisted_6,
          _createVNode(_component_DataWrapper, {
            label: "Status Hub",
            class: "my-6"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_Toggle, {
                  onChange: _ctx.onUpdateStatus,
                  modelValue: _ctx.form.isActive,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.isActive = $event)),
                  textActive: "Aktif",
                  textInactive: "Tidak Aktif",
                  customLabel: true
                }, {
                  "custom-label": _withCtx(() => [
                    _createVNode("div", _hoisted_9, _toDisplayString(_ctx.labelToggle), 1)
                  ]),
                  _: 1
                }, 8, ["onChange", "modelValue"])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 2
    }, [
      (_ctx.isEditPage)
        ? {
            name: "sub-data",
            fn: _withCtx(() => [
              _createVNode(_component_DataWrapper, {
                label: "Status Hub",
                value: _ctx.form.status ? 'Aktif' : 'Tidak Aktif',
                customStyleValue: `max-w-max font-medium rounded-full px-2 py-0 ${
          _ctx.form.status ? 'bg-green-lp-300' : 'bg-red-300'
        } ${_ctx.form.status ? 'text-green-lp-200' : 'text-red-lp-200'} capitalize`
              }, null, 8, ["value", "customStyleValue"]),
              _createVNode(_component_DataWrapper, {
                label: "Tanggal Dibuat",
                value: _ctx.formatDate(_ctx.form.hubCreatedAt),
                caption: _ctx.form.hubCreatedBy
              }, null, 8, ["value", "caption"]),
              _createVNode(_component_DataWrapper, {
                label: "Terakhir Diperbarui",
                value: _ctx.formatDate(_ctx.form.hubUpdatedAt),
                caption: _ctx.form.hubUpdatedBy
              }, null, 8, ["value", "caption"])
            ])
          }
        : undefined
    ]), 1032, ["onBack", "title", "vertical-separator", "fullpage", "loading", "error", "errorType"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ])
  ], 64))
}